export const AvatarNavbarAnimalsIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91921)">
        <path
          d="M12.46 7.17L16.5 9.19"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M16.04 4.38L14.37 2.71L12.09 8.04C12.03 8.19 11.92 8.31 11.78 8.4C11.65 8.49 11.49 8.54 11.33 8.54H5.21C4.77 8.54 4.34 8.72 4.03 9.03C3.72 9.34 3.54 9.77 3.54 10.21V18.54H6.04V16.24C6.04 16.11 6.07 15.98 6.13 15.87L7.71 12.71L12.14 14.19C12.3 14.24 12.45 14.35 12.55 14.49C12.65 14.63 12.71 14.8 12.71 14.98V18.54H15.21V14.38L16.87 7.71H17.71C18.15 7.71 18.57 7.53 18.89 7.22C19.2 6.91 19.37 6.48 19.37 6.04V4.38H16.04Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M10.21 6.04C8.88 6.04 7.61 5.51 6.67 4.58C5.74 3.64 5.21 2.37 5.21 1.04"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M1.04 6.04C1.04 6.7 1.3 7.34 1.77 7.81C2.24 8.28 2.88 8.54 3.54 8.54H4.37"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91921">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
